import { useState } from "react";
import { DirectorUser } from "@po-management/types";
import { useDirectors } from "../hooks/useDirectors";

interface ApproverSelectModalProps {
  onConfirm: (approver: DirectorUser) => void;
  onCancel: () => void;
}

export function ApproverSelectModal({ onConfirm, onCancel }: ApproverSelectModalProps): JSX.Element {
  const { directors, loading, error } = useDirectors();
  const [selected, setSelected] = useState<DirectorUser | null>(null);

  return (
    <div style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)",
      display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000,
    }}>
      <div style={{ background: "#fff", borderRadius: 8, padding: 24, width: 400, maxWidth: "90vw" }}>
        <h3 style={{ margin: "0 0 16px", color: "#5B6A8A" }}>Select Approver</h3>
        <p style={{ fontSize: 13, color: "#666", marginBottom: 16 }}>
          Choose a Director to review and approve this PO.
        </p>

        {loading && <p style={{ fontSize: 13, color: "#888" }}>Loading directors...</p>}
        {error && <p style={{ fontSize: 13, color: "red" }}>{error}</p>}

        {!loading && !error && directors.length === 0 && (
          <p style={{ fontSize: 13, color: "#888" }}>
            No directors found. Ask a Super Administrator to assign the <strong>PO.Director</strong> role
            to at least one user in Azure AD (Enterprise Applications → your app → Users and groups).
          </p>
        )}

        {directors.map((d) => (
          <div
            key={d.oid}
            onClick={() => setSelected(d)}
            style={{
              padding: "10px 12px", borderRadius: 4, cursor: "pointer", marginBottom: 6,
              border: `1px solid ${selected?.oid === d.oid ? "#5B6A8A" : "#dde"}`,
              background: selected?.oid === d.oid ? "#f0f4ff" : "#fff",
            }}
          >
            <div style={{ fontWeight: 500, fontSize: 14 }}>{d.name}</div>
            <div style={{ fontSize: 12, color: "#888" }}>{d.email}</div>
          </div>
        ))}

        <div style={{ display: "flex", gap: 8, marginTop: 20 }}>
          <button
            onClick={() => selected && onConfirm(selected)}
            disabled={!selected}
            style={{
              padding: "8px 20px", background: selected ? "#5B6A8A" : "#ccc",
              color: "#fff", border: "none", borderRadius: 4,
              cursor: selected ? "pointer" : "default",
            }}
          >
            Confirm
          </button>
          <button
            onClick={onCancel}
            style={{ padding: "8px 16px", background: "#fff", border: "1px solid #ccc", borderRadius: 4, cursor: "pointer" }}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
